module.exports = "/_next/static/media/02f962776f08092120336a3ddd37d321.png";